import React from 'react';
import { Item } from '../item.jsx';
import { useFlowStore, useSessionStore, useFlowRegistry } from '../../store/react';
import { selectCurrentItem, selectLoopsDefinitions } from '../../store/selectors';
import { getShortLoopName } from '../../utils.js';
import { isRealFirstIteration } from '../../items/utils';

export default function ItemWrapper({ loopType }) {
    const registry = useFlowRegistry();
    const currentItem = useFlowStore((s) => selectCurrentItem(s, registry));
    const itemsStates = useFlowStore((s) => s.itemsStates);
    const loops = useFlowStore((s) => s.loops);
    const globals = useFlowStore((s) => s.globals);
    const loopsDefinitions = useFlowStore((s) => selectLoopsDefinitions(s, registry));
    const hasErrors = useFlowStore((s) => s.hasErrors);
    const setAttribute = useFlowStore((s) => s.setAttribute);
    const setApplyToAll = useFlowStore((s) => s.setApplyToAll);
    const advance = useFlowStore((s) => s.advance);
    const mode = useSessionStore((s) => s.mode);

    if (!currentItem) return null;
    const loopName = currentItem.loopName;
    const loop = loopName ? loops[loopName] : null;
    const loopIndex = loop ? loop.index : '';
    const initialState = loop ? loop.states[loop.index - 1][currentItem.id] : itemsStates[currentItem.id];
    const firstRealIteration = loop ? (loopIndex === 1 || isRealFirstIteration(loop, loopIndex)) : true;
    let hasMoreIterations;
    if (loop && loopName) {
        const friendlyLoop = loopsDefinitions[getShortLoopName(loopName)];
        if (friendlyLoop && typeof friendlyLoop.hasMoreIterations === 'function') {
            hasMoreIterations = friendlyLoop.hasMoreIterations(itemsStates, globals, loops);
        }
    }
    const showApplyToAll = !!currentItem.allowApplyAll && firstRealIteration && !!hasMoreIterations;

    return (
        <Item
            item={currentItem}
            loopIndex={loopIndex}
            isObserver={mode === 'observer'}
            values={initialState && initialState.values}
            preliminaries={initialState && initialState.preliminaries}
            applyToAll={initialState && initialState.applyToAll}
            showApplyToAll={showApplyToAll}
            hasErrors={hasErrors}
            loopType={loopType}
            onChange={(fieldIndex, value) => setAttribute(currentItem.id, 'values', fieldIndex, value)}
            onApplyToAll={(value) => setApplyToAll(currentItem.id, value)}
            onItemPreliminaryChange={(fieldIndex, value) => setAttribute(currentItem.id, 'preliminaries', fieldIndex, value)}
            onSubmit={() => advance()}
            preliminarySection={false}
            key={`c-${currentItem.flowId || ''}-f-${currentItem.id}-l-${loopIndex}`}
        />
    );
}
